import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';
import { faChevronDown } from '@rtkwlf/pro-solid-svg-icons/faChevronDown';

export const accordionTheme: Pick<
  Components<Theme>,
  'MuiAccordion' | 'MuiAccordionSummary'
> = {
  MuiAccordionSummary: {
    defaultProps: {
      expandIcon: <FontAwesomeIcon icon={faChevronDown} />,
    },
  },
};
